import { Observable } from 'rxjs';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { InterceptorFnsClosure } from '../interfaces/miscellaneous.interface';

/**
 * The function `UrlPatcherInterceptor` is a TypeScript function that returns an interceptor function
 * closure which appends the API URL to the request URL.
 * @param {string} API_URL - The `API_URL` parameter is a string that represents the base URL of the
 * API that you want to make requests to.
 * @returns an interceptor function.
 */
export function UrlPatcherInterceptor(API_URL: string): InterceptorFnsClosure {
  return (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
  ): Observable<HttpEvent<unknown>> => {
    return next(request.clone({ url: `${API_URL}${request.url}` }));
  };
}
